import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
import CustomButton from "../Buttons/CustomButton";
import { useTenantContext } from "./TenantContext";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import { useAuth } from "../../Utility/AuthProvider";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { GetMediaURL } from "../../Utility/APICall";
import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";
// import { getTenantProfileImageURL, getTenantDocumentURL } from "../../utils/tenantMediaUtils";

import {
  getTenantDocumentURL,
  getTenantProfileImageURL,
  debugTenantData,
  testImageLoadability,
  getValidatedTenantDocumentURL,
} from "../../Utility/tenantFileUtils";

const AddMoreTenant = () => {
  const navigate = useNavigate();
  const { unitId } = useParams();
  const location = useLocation();
  const { jwt } = useAuth();

  const { fetchTenantById, currentAgreementTenants } = useTenantContext();

  // Get data from navigation state
  const agreementBody = location.state?.agreementBody || null;
  const unit = location.state?.unit || null;
  const initialTenantList = location.state?.tenantList || [];
  const isUpdate = location.state?.isUpdate || false;
  const originalAgreement = location.state?.originalAgreement || null;

  // For modification flow
  const modifiedAgreementData = location.state?.modifiedAgreementData || null;
  const isModifying = location.state?.isModifying || false;

  //   const { currentAgreementTenants, addToCurrentAgreement } = useTenantContext();

  // Use context tenants instead of or alongside local state
  const contextTenants = currentAgreementTenants || [];
  const navigationTenants = location.state?.tenantList || [];

  const [tenantList, setTenantList] = useState(
    navigationTenants.length > 0
      ? navigationTenants.filter((tenant) => Object.keys(tenant).length > 0)
      : contextTenants.filter((tenant) => Object.keys(tenant).length > 0)
  );

  // State for image modal
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setImageModalOpen] = useState(false);

  // Get initials for profile display
  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : "";
    const last = lastName ? lastName.charAt(0).toUpperCase() : "";
    return `${first}${last}`;
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // For modification flow - fetch existing tenants if not already loaded
  //   useEffect(() => {
  //     if (
  //       isModifying &&
  //       originalAgreement?.tenant_id &&
  //       tenantList.length === 0
  //     ) {
  //       fetchExistingTenants();
  //     }
  //   }, [isModifying, originalAgreement]);

  // For modification flow - fetch existing tenants using TenantContext
  useEffect(() => {
    if (
      isModifying &&
      originalAgreement?.tenant_id &&
      tenantList.length === 0
    ) {
      console.log("=== DEBUG INFO ===");
      console.log("Location state:", location.state);
      console.log("isModifying:", isModifying);
      console.log("originalAgreement:", originalAgreement);
      console.log("originalAgreement.tenant_id:", originalAgreement.tenant_id);
      console.log("===================");

      fetchExistingTenants();
    }
  }, [isModifying, originalAgreement]);

  //   const fetchExistingTenants = async () => {
  //     try {
  //       setLoading(true);
  //       const localTenantList = [];

  //       // Fetch each tenant similar to mobile app
  //       for (let i = 0; i < originalAgreement.tenant_id.length; i++) {
  //         const body = {
  //           tenant_id: originalAgreement.tenant_id[i],
  //         };

  //         const response = await APICall(
  //           "POST",
  //           paths.tenant.fetch,
  //           body,
  //           undefined,
  //           jwt
  //         );

  //         if (response.status === "success") {
  //           const tenant = response.response;

  //           // Parse media if it's a string
  //           if (tenant && tenant.media && !(tenant.media instanceof Object)) {
  //             tenant.media = JSON.parse(tenant.media);
  //           }

  //           const tenantBody = {
  //             aadhar_back: tenant.media?.aadhar_back,
  //             aadhar_front: tenant.media?.aadhar_front,
  //             pan: tenant.media?.pan,
  //             profile_picture: tenant.media?.profile_picture,
  //             rent_agreement: tenant.media?.rent_agreement,
  //             first_name: tenant.first_name,
  //             last_name: tenant.last_name,
  //             mobile: tenant.mobile,
  //             tenant_in_agreement: true,
  //             tenant_in_db: true,
  //             is_media_modified: false,
  //             entity_id: tenant.entity_id,
  //           };

  //           localTenantList.push(tenantBody);
  //         } else {
  //           throw new Error(
  //             `Failed to fetch tenant ${originalAgreement.tenant_id[i]}`
  //           );
  //         }
  //       }

  //       setTenantList(localTenantList);
  //     } catch (err) {
  //       console.error("Error fetching tenants:", err);
  //       setError("Failed to load existing tenants");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  // Update tenantList when coming back from AddNewTenant screen

  const fetchExistingTenants = async () => {
    try {
      setLoading(true);
      setError(null);
      const localTenantList = [];

      console.log("Fetching existing tenants...");
      console.log("Tenant IDs to fetch:", originalAgreement.tenant_id);

      if (
        !originalAgreement.tenant_id ||
        originalAgreement.tenant_id.length === 0
      ) {
        console.log("No tenant IDs found in agreement");
        setTenantList([]);
        return;
      }

      // Use TenantContext's fetchTenantById method
      for (let i = 0; i < originalAgreement.tenant_id.length; i++) {
        const tenantId = originalAgreement.tenant_id[i];
        console.log(
          `Fetching tenant ${i + 1}/${originalAgreement.tenant_id.length}: ${tenantId}`
        );

        try {
          // Use the TenantContext method
          const tenant = await fetchTenantById(tenantId);

          if (tenant) {
            console.log(`Successfully fetched tenant:`, tenant);

            // Parse media if it's a string
            let parsedMedia = {};
            if (tenant.media) {
              if (typeof tenant.media === "string") {
                try {
                  parsedMedia = JSON.parse(tenant.media);
                } catch (parseError) {
                  console.warn("Failed to parse tenant media:", parseError);
                  parsedMedia = {};
                }
              } else {
                parsedMedia = tenant.media;
              }
            }

            const tenantBody = {
              aadhar_back: parsedMedia?.aadhar_back,
              aadhar_front: parsedMedia?.aadhar_front,
              pan: parsedMedia?.pan,
              profile_picture: parsedMedia?.profile_picture,
              rent_agreement: parsedMedia?.rent_agreement,
              first_name: tenant.first_name,
              last_name: tenant.last_name,
              mobile: tenant.mobile,
              tenant_in_agreement: true,
              tenant_in_db: true,
              is_media_modified: false,
              entity_id: tenant.entity_id,
            };

            localTenantList.push(tenantBody);
            console.log(
              `Successfully processed tenant: ${tenant.first_name} ${tenant.last_name}`
            );
          } else {
            console.error(
              `Failed to fetch tenant ${tenantId}: No data returned`
            );
            setError(
              `Failed to load tenant ${tenantId}. Other tenants loaded successfully.`
            );
          }
        } catch (tenantError) {
          console.error(`Error fetching tenant ${tenantId}:`, tenantError);
          setError(
            `Failed to load tenant ${tenantId}. Other tenants loaded successfully.`
          );
        }
      }

      console.log("Final tenant list:", localTenantList);
      setTenantList(localTenantList);
    } catch (err) {
      console.error("Error fetching tenants:", err);
      setError("Failed to load existing tenants");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Location state changed:", location.state);
    console.log("Current tenant list:", tenantList);
    if (location.state?.fromAddNewTenant) {
      const updatedList = location.state.tenantList.filter(
        (tenant) => Object.keys(tenant).length > 0
      );
      setTenantList(updatedList);
    }
  }, [location.state]);

  const handleAddAnotherTenant = () => {
    const addTenantRoute = isModifying
      ? `/dashboard/agreements/${originalAgreement.entity_id}/modify/add-tenant`
      : `/dashboard/my-properties/${unitId}/add-agreement/add-new-tenant`;

    const stateData = isModifying
      ? {
          modifiedAgreementData,
          originalAgreement,
          tenantList: [...tenantList],
          isModifying: true,
          fromReviewTenants: true,
        }
      : {
          agreementBody,
          unit,
          tenantList: [...tenantList],
          fromAddMoreTenant: true,
          isUpdate,
          originalAgreement,
        };

    navigate(addTenantRoute, { state: stateData });
  };

  const handleContinue = () => {
    const continueRoute = isModifying
      ? `/dashboard/agreements/${originalAgreement.entity_id}/modify/overview`
      : `/dashboard/my-properties/${unitId}/add-agreement/agreement-overview`;

    const stateData = isModifying
      ? {
          modifiedAgreementData,
          originalAgreement,
          tenantList: tenantList,
          isModifying: true,
        }
      : {
          agreementBody,
          unit,
          tenantList: tenantList,
          isUpdate,
          originalAgreement,
        };

    navigate(continueRoute, { state: stateData });
  };

  const handleEditTenant = (tenantIndex) => {
    const tenantToEdit = tenantList[tenantIndex];
    const editTenantRoute = isModifying
      ? `/dashboard/agreements/${originalAgreement.entity_id}/modify/add-tenant`
      : `/dashboard/my-properties/${unitId}/add-agreement/add-new-tenant`;

    const stateData = isModifying
      ? {
          modifiedAgreementData,
          originalAgreement,
          tenantList: tenantList,
          isModifying: true,
          fromReviewTenants: true,
          editingTenant: tenantToEdit,
          editingIndex: tenantIndex,
        }
      : {
          agreementBody,
          unit,
          tenantList: tenantList,
          fromAddMoreTenant: true,
          isUpdate,
          originalAgreement,
          editingTenant: tenantToEdit,
          editingIndex: tenantIndex,
        };

    navigate(editTenantRoute, { state: stateData });
  };

  const handleRemoveTenant = (tenantIndex) => {
    const updatedList = tenantList.filter((_, index) => index !== tenantIndex);
    setTenantList(updatedList);
  };

  const viewImage = async (imageUrl, tenant = null, docType = null) => {
    console.log("🖼️ viewImage called:", { imageUrl, tenant, docType });

    if (!imageUrl) {
      console.error("❌ No image URL provided");
      alert("Image not available - no URL generated");
      return;
    }

    // Debug tenant data if provided
    if (tenant && docType) {
      debugTenantData(tenant, `AddMoreTenant-${docType}`);
    }

    // Test if image loads before showing modal
    console.log("🧪 Testing image loadability...");
    const isLoadable = await testImageLoadability(imageUrl, jwt);

    if (!isLoadable) {
      console.error("❌ Image failed to load:", imageUrl);
      alert(`Failed to load image. URL: ${imageUrl.substring(0, 50)}...`);
      return;
    }

    console.log("✅ Image verified, opening modal");
    setSelectedImage(imageUrl);
    setImageModalOpen(true);
  };

  // Get profile image for tenant

  // const getTenantProfileImage = (tenant) => {
  //   if (tenant.media?.profile?.location) {
  //     return tenant.media.profile.location;
  //   }
  //   if (tenant.media?.profile_picture?.location) {
  //     // return tenant.media.profile_picture.location;
  //     return GetMediaURL(
  //       paths.media.download,
  //       tenant.media.profile_picture.location,
  //       { quality: 80 }
  //     );
  //   }
  //   if (tenant.profile_picture) {
  //     return typeof tenant.profile_picture === "string"
  //       ? tenant.profile_picture
  //       : URL.createObjectURL(tenant.profile_picture);
  //   }
  //   return null;
  // };
  // Replace the existing getTenantProfileImage function with this:
  // const getTenantProfileImage = (tenant) => {
  //   return getTenantProfileImageURL(tenant, { quality: 80 });
  // };

  // Updated DocumentStatus component with enhanced debugging
  const DocumentStatus = ({ tenant }) => {
    // Debug the entire tenant data structure first
    debugTenantData(tenant, "DocumentStatus");

    const documents = [
      { key: "profile_picture", label: "Profile", icon: "👤" },
      { key: "aadhar_front", label: "Aadhar Front", icon: "🆔" },
      { key: "aadhar_back", label: "Aadhar Back", icon: "🆔" },
      { key: "pan", label: "PAN", icon: "📄" },
      { key: "rent_agreement", label: "Agreement", icon: "📋" },
    ];

    const hasDocument = (docKey) => {
      const hasDoc = !!(
        tenant[docKey]?.location ||
        tenant.media?.[docKey]?.location ||
        tenant[docKey]
      );
      console.log(`📋 ${docKey} hasDocument:`, hasDoc);
      return hasDoc;
    };

    const getDocumentURL = (docKey) => {
      console.log(`🔍 Getting URL for ${docKey}...`);
      const url = getTenantDocumentURL(tenant, docKey, { quality: 80 });
      console.log(`📄 Generated URL for ${docKey}:`, url);
      return url;
    };

    return (
      <div className="flex flex-wrap gap-1 mt-2">
        {documents.map((doc) => {
          const hasDoc = hasDocument(doc.key);
          const docURL = getDocumentURL(doc.key);

          return (
            <div
              key={doc.key}
              className={`flex items-center space-x-1 px-2 py-1 rounded text-xs ${
                hasDoc
                  ? "bg-green-100 text-green-800"
                  : "bg-gray-100 text-gray-500"
              }`}
            >
              <span>{doc.icon}</span>
              <span>{doc.label}</span>
              {hasDoc && docURL && (
                <button
                  onClick={async () => {
                    console.log(`🖱️ Clicked to view ${doc.key}`);
                    await viewImage(docURL, tenant, doc.key);
                  }}
                  className="ml-1 text-blue-600 hover:text-blue-800"
                >
                  <FaEye size={10} />
                </button>
              )}
              {hasDoc && !docURL && (
                <span
                  className="ml-1 text-red-500"
                  title="URL generation failed"
                >
                  ⚠️
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p>Loading tenants...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full p-6">
      <div className="container mx-auto max-w-4xl">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">
            {isModifying ? "Review Tenants" : "Tenants List"}
          </h2>
          {isModifying && (
            <p className="text-gray-600">
              Review existing tenants and add more if needed
            </p>
          )}
          {unit && (
            <div className="text-gray-600 mb-4">
              <p className="font-medium text-lg">{unit.unit_name}</p>
              <p>
                {unit.building_name}, {unit.address}
              </p>
            </div>
          )}
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800">{error}</p>
          </div>
        )}

        {/* Tenants List Section */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="text-xl font-semibold">
                {isModifying ? "Current Tenants" : "Tenants List"}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {isModifying
                  ? `${tenantList.length} tenant${tenantList.length !== 1 ? "s" : ""}`
                  : "You can add multiple tenants in single flat"}
              </p>
            </div>
          </div>

          {/* Tenant List */}
          <div className="space-y-4">
            {tenantList.length > 0 ? (
              tenantList.map((tenant, index) => (
                <div
                  key={tenant.entity_id || `tenant-${index}`}
                  className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50"
                >
                  <div className="flex items-center space-x-4">
                    {/* Profile Picture or Initials */}
                    <CustomImage
                      location={
                        // Try multiple possible locations
                        tenant.profile_picture?.location ||
                        tenant.media?.profile_picture?.location ||
                        null
                      }
                      className="w-12 h-12 rounded-full"
                      imageType={IMAGE_TYPES.PROFILE}
                      initials={getInitials(
                        tenant.first_name,
                        tenant.last_name
                      )}
                      altText={`${tenant.first_name} ${tenant.last_name}`}
                      jwt={jwt} // Make sure JWT is passed for authentication
                    />

                    {/* Tenant Info */}
                    <div>
                      <div className="flex items-center space-x-2">
                        <p className="font-medium text-gray-900">
                          {tenant.first_name} {tenant.last_name}
                        </p>
                        {/* Primary/Secondary Labels */}
                        {index === 0 && (
                          <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
                            Primary
                          </span>
                        )}
                        {index > 0 && (
                          <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-medium">
                            Secondary
                          </span>
                        )}
                        {tenant.tenant_in_agreement && (
                          <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium">
                            Existing Tenant
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-500">{tenant.mobile}</p>

                      {/* Document Status */}
                      <DocumentStatus tenant={tenant} />

                      {/* Verification Status */}
                      <div className="flex space-x-4 mt-2 text-xs">
                        {tenant.aadhar_verified && (
                          <span className="text-green-600">
                            ✓ Aadhar Verified
                          </span>
                        )}
                        {tenant.pan_verified && (
                          <span className="text-green-600">✓ PAN Verified</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex items-center space-x-2">
                    {!tenant.tenant_in_agreement && (
                      <>
                        <button
                          onClick={() => handleEditTenant(index)}
                          className="text-blue-600 hover:text-blue-800 text-sm font-medium p-2 hover:bg-blue-50 rounded"
                          title="Edit tenant"
                        >
                          {/* → */}
                          <FaEdit size={14} />
                        </button>
                        <button
                          onClick={() => handleRemoveTenant(index)}
                          className="text-red-500 hover:text-red-700 text-sm font-medium p-2 hover:bg-red-50 rounded"
                          title="Remove tenant"
                        >
                          {/* Remove */}
                          <FaTrash size={14} />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                <p>No tenants added yet</p>
              </div>
            )}

            {/* Add Another Tenant Button */}
            <button
              onClick={handleAddAnotherTenant}
              className="w-full flex items-center justify-center space-x-2 p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors group"
            >
              <div className="w-8 h-8 rounded-full border-2 border-gray-400 group-hover:border-blue-500 flex items-center justify-center group-hover:bg-blue-500 transition-colors">
                <FaPlus className="text-gray-400 group-hover:text-white text-sm" />
              </div>
              <span className="text-blue-600 font-medium">
                Add Another Tenant
              </span>
              <span className="text-gray-400">→</span>
            </button>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between">
          {isModifying && (
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            >
              Back
            </button>
          )}
          <div className={isModifying ? "" : "ml-auto"}>
            <CustomButton
              tailwindClasses="bg-blue-500 text-white px-8 py-3 text-lg font-medium hover:bg-blue-600"
              label={isModifying ? "Continue to Overview" : "Continue"}
              onClick={handleContinue}
              disabled={tenantList.length === 0}
            />
          </div>
        </div>
        {/* Image Modal */}
        {isImageModalOpen && selectedImage && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
            <div className="relative max-w-4xl max-h-screen p-4">
              <button
                onClick={() => setImageModalOpen(false)}
                className="absolute top-2 right-2 text-white hover:text-gray-300 text-2xl z-10"
              >
                ×
              </button>
              <img
                src={selectedImage}
                alt="Document preview"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddMoreTenant;
